import { inject, Service } from '@angular/core';
import H from '@here/maps-api-for-javascript';
import { TranslateService } from '@ngx-translate/core';
import { ONYX_HERE_MAPS_API_KEY } from '../../constants';

@Service()
export class OnyxMapService {
  private readonly apiKey = inject(ONYX_HERE_MAPS_API_KEY);
  private readonly translateService = inject(TranslateService);

  private platform: H.service.Platform | null = null;

  public getDefaultLayers(): H.service.Platform.DefaultLayers {
    const language =
      this.translateService.getCurrentLang() ??
      this.translateService.getFallbackLang() ??
      undefined;
    const platform = this.getPlatform();

    return platform.createDefaultLayers({ lg: language });
  }

  private getPlatform(): H.service.Platform {
    this.platform ??= new H.service.Platform({ apikey: this.apiKey });
    return this.platform;
  }
}
